import {Component, Input, OnInit} from '@angular/core';
import {
  RefModelNode,
  RefModelStoreService,
  Refmodel,
  User,
  UserTeam
} from '@q9elements/ui-kit/common';

import {environment} from '../../../../environments/environment';
import {TreeListViewEnum} from '../../../editor-interface/models/enums/TreeListView.enum';
import {CustomViewService} from '../../../editor-interface/services/custom-view.service';
import {ReportDialogService} from '../../services/report-dialog.service';
import {ShareRefModelDialogService} from '../../services/share-refModel-dialog.service';

@Component({
  selector: 'app-impact-toolbar',
  templateUrl: './impact-toolbar.component.html',
  styleUrls: ['./impact-toolbar.component.scss']
})
export class ImpactToolbarComponent implements OnInit {
  @Input() title: string;
  @Input() multiple = false;
  @Input() node: RefModelNode;
  @Input() showTopDivider = true;

  public readonly showShareRefModelButton = this.rmeStore.canShareRefModel;
  protected readonly TreeListViewEnum = TreeListViewEnum;

  private user: User;
  private userInTeam: UserTeam;
  private refModel: Refmodel;
  private anchorTarget: string;

  constructor(
    private rmeStore: RefModelStoreService,
    private customViewService: CustomViewService,
    private reportDialogService: ReportDialogService,
    private shareRefModelDialogService: ShareRefModelDialogService
  ) {}

  ngOnInit(): void {
    this.user = this.rmeStore.user;
    this.userInTeam = this.rmeStore.user.userInTeam;
    this.refModel = this.rmeStore.refModel;
    this.anchorTarget = this.rmeStore.anchorTarget;
    this.node = this.rmeStore.selectedNode;
  }

  public goToRefModelsList(): void {
    const index = this.user.userInTeam.teamIndex || 0;
    const refModelPath = this.refModel.external ? 'referencemodels-external' : 'referencemodels';
    const url = `${environment.MAIN_APP_URL}/t/${index}/${refModelPath}`;

    window.open(url, this.anchorTarget);
  }

  public showSavedReports($event: any) {
    const currentView = this.customViewService.selectedView;

    this.reportDialogService.openReportDialog(
      $event,
      this.rmeStore.selectedNode,
      this.refModel,
      this.rmeStore.rootData,
      currentView
    );
  }

  public onShareRefModel() {
    this.shareRefModelDialogService.openRefModelShareDialog();
  }
}
